import PropTypes from 'prop-types';
import { declMod } from '@yandex-lego/i-bem-react';
export default declMod({
  hasAccentLetter: true
}, {
  block: 'user-account',
  elem: 'name',
  content: function content(_ref) {
    var text = _ref.text,
        children = _ref.children;

    if (text && !children) {
      var name = String(text); // surround # or @ at 0 or 1 index with zero-width spaces for :first-letter to work correctly

      name = name.replace(/^([^@#]?)([@#])/, "$1\u200B$2\u200B");
      return [name];
    }

    return children;
  }
}, {
  propTypes: {
    text: PropTypes.string
  }
});